import { ConditionApi } from '@voladeum/client';
import { uuidv4 } from 'utils/uuid';

import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants';
import { normalizeIndicator } from '../indicators/normalizers';

import { Condition } from './types';

export const normalizeConditions = (conditions: ConditionApi[] = EMPTY_ARRAY): Condition[] =>
  conditions.map((condition) => normalizeCondition(condition));

export const normalizeCondition = (condition: ConditionApi): Condition => ({
  ...condition,
  measure: normalizeIndicator(condition.measure || EMPTY_OBJECT),
  threshold: normalizeIndicator(condition.threshold || EMPTY_OBJECT),
  uuid: uuidv4(),
});
